(function () {
  /**
   * @ngdoc module
   * @name akitabox.mobile.directives.backNav
   */
  angular
    .module("akitabox.mobile.directives.backNav", [
      "ngMaterial",
      "akitabox.core",
      "akitabox.core.services.history",
      "akitabox.mobile.constants",
    ])
    .directive("abmBackNav", AbmBackNavDirective);

  /**
   * @ngdoc directive
   * @module akitabox.mobile.directives.backNav
   * @name AbmBackNavDirective
   *
   * @restrict EA
   *
   * @description
   * `abm-back-nav` can be used as an element or attribute directive. The user can specify a state to navigate
   * back to (nav-back) or a default navigation state (nav-default) that will be used when there is no history.
   * If neither are specified it will navigate to the previous state or show the dashboard if no state is available.
   *
   * @usage
   * <hljs lang="html">
   *
   * <abm-back-nav nav-back="'app.home'" nav-default="'app.dashboard'"></abm-back-nav>
   *
   * <!-- OR -->
   *
   * <md-button class="md-icon-button" aria-label="Back" abm-back-nav nav-back="'app.home'" nav-default="'app.dashboard'">
   *   <md-icon class="material-icons">arrow_back</md-icon>
   * </md-button>
   *
   * </hljs>
   */
  function AbmBackNavDirective(
    // Angular
    $compile,
    $http,
    $templateCache,
    $log,
    // Services
    HistoryService
  ) {
    return {
      restrict: "EA",
      link: postLink,
      scope: {
        navBack: "=?",
        navDefault: "=?",
      },
    };

    function postLink($scope, $element) {
      var TAG_NAME = "ABM-BACK-NAV";
      var templateUrl = "app/mobile/directives/back-nav/back-nav.html";

      // Check directive usage
      // If used as an element, replace content with back button (with abm-back-nav attribute)
      // If used as an attribute, add click event
      if ($element[0].tagName === TAG_NAME) {
        $http
          .get(templateUrl, { cache: $templateCache })
          .then(function (response) {
            if (response.status === 200) {
              $element.replaceWith($compile(response.data)($scope));
            } else {
              $log.error("<abm-back-nav> unable to retrieve template");
            }
          });
      } else {
        $element.on("click", onClick);
      }

      /**
       * Attempt to navigate the provided back state or the previous state.
       * If history is empty, navigate to the provided default state.
       */
      function onClick() {
        if (!angular.isEmpty($scope.navBack)) {
          navigateTo($scope.navBack);
        } else if (HistoryService.isEmpty()) {
          navigateTo($scope.navDefault);
        } else {
          HistoryService.back();
        }
      }

      /**
       * Navigate to a state or menu
       *
       * @param {String} name State or menu name
       */
      function navigateTo(state) {
        // check to see if state is a string (aka not an object)
        if (angular.isString(state)) {
          HistoryService.back(state);
          // check to see if state is an object
        } else if (
          state &&
          Object.prototype.hasOwnProperty.call(state, "name")
        ) {
          HistoryService.back(state.name, state.params);
          // else (e.g. if state is empty), go to the default
        } else {
          HistoryService.back("app.dashboard");
        }
      }
    }
  }
})();
